import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={100}
      height={100}
      fill="none"
    >
      <g filter="url(#a)">
        <path
          fill="#33373F"
          d="M14.286 15.131V84.87c0 3.497 3.203 6.34 7.143 6.34h57.143c3.94 0 7.143-2.843 7.143-6.34V15.131c0-3.497-3.203-6.34-7.143-6.34H21.429c-3.94 0-7.143 2.843-7.143 6.34Zm53.572 6.34H32.143c-1.975 0-3.571-1.416-3.571-3.17 0-1.753 1.596-3.17 3.571-3.17h35.715c1.975 0 3.571 1.417 3.571 3.17 0 1.754-1.596 3.17-3.571 3.17Z"
        />
        <path
          stroke="#7E8187"
          strokeWidth={0.56}
          d="M14.566 84.87V15.13c0-3.312 3.046-6.06 6.863-6.06h57.143c3.817 0 6.863 2.748 6.863 6.06V84.87c0 3.312-3.046 6.06-6.863 6.06H21.429c-3.817 0-6.863-2.748-6.863-6.06ZM32.143 21.75h35.715c2.097 0 3.851-1.511 3.851-3.45 0-1.938-1.754-3.45-3.851-3.45H32.143c-2.098 0-3.851 1.512-3.851 3.45 0 1.939 1.753 3.45 3.851 3.45Z"
        />
      </g>
      <mask
        id="b"
        width={72}
        height={86}
        x={14}
        y={5}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path fill="#D9D9D9" d="M14 5h72v86H14z" />
      </mask>
      <g mask="url(#b)">
        <path
          stroke="#464A50"
          strokeWidth={0.2}
          d="M88.773 63.072c0 6.187-4.536 11.81-11.917 15.89-7.378 4.08-17.577 6.606-28.848 6.606-11.271 0-21.47-2.526-28.848-6.605-7.381-4.082-11.917-9.704-11.917-15.89 0-6.187 4.536-11.81 11.917-15.891 7.378-4.08 17.577-6.606 28.848-6.606 11.271 0 21.47 2.526 28.848 6.606 7.381 4.081 11.917 9.704 11.917 15.89Z"
        />
      </g>
      <ellipse cx={50.001} cy={62.569} fill="#2A2D34" rx={22.115} ry={12.981} />
      <rect
        width={24.972}
        height={27.556}
        x={40.027}
        y={33}
        fill="#6D7380"
        rx={3}
      />
      <path fill="#33373F" d="M36.583 39.028h19.806v20.667H36.583z" />
      <path
        fill="#C6C8CB"
        d="M43.113 66.575a1.556 1.556 0 0 1-1.032-.464l-2.066-2.36a.959.959 0 0 0-1.41-.075l-.073.075-2.077 2.36a1.96 1.96 0 0 1-1.082.464.65.65 0 0 1-.462-.1 1.377 1.377 0 0 1-.639-.486 1.448 1.448 0 0 1-.272-.77V37.863a1.444 1.444 0 0 1 .399-1.007c.127-.132.28-.236.447-.307.167-.07.346-.106.527-.105H58.46c.362 0 .71.148.967.412.257.263.403.62.406.995v27.318c-.01.28-.103.55-.266.775a1.34 1.34 0 0 1-.645.48 1.486 1.486 0 0 1-.522.101 1.182 1.182 0 0 1-.519-.124 1.221 1.221 0 0 1-.417-.34l-2.017-2.336a.99.99 0 0 0-1.422-.063l-2.224 2.436c-.132.138-.289.247-.462.321a1.38 1.38 0 0 1-1.555-.32l-2.053-2.349a.998.998 0 0 0-.69-.34.967.967 0 0 0-.72.265l-.073.076-2.126 2.36c-.268.28-.628.446-1.009.464Zm-2.187-15.63c-.34.033-.656.196-.886.457-.23.262-.358.602-.358.955 0 .354.128.694.358.955.23.261.546.425.886.458h12.018a1.333 1.333 0 0 0 1.053-.364c.141-.132.254-.294.331-.475a1.46 1.46 0 0 0 0-1.147 1.417 1.417 0 0 0-.331-.476 1.333 1.333 0 0 0-1.053-.363H40.926Zm0-6.792c-.358.016-.697.17-.95.434-.252.263-.399.614-.41.985.011.368.159.719.411.98.253.261.592.413.95.426h9.477c.363-.003.712-.151.972-.413s.413-.618.425-.993a1.504 1.504 0 0 0-.418-.986 1.413 1.413 0 0 0-.955-.433h-9.502Z"
      />
      <defs>
        <filter
          id="a"
          width={81.429}
          height={92.418}
          x={9.286}
          y={5.791}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.0783854 0 0 0 0 0.100868 0 0 0 0 0.145833 0 0 0 0.62 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11064_373"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_11064_373"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default Icon;
